import { Draft } from '@reduxjs/toolkit';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { hasUserInput } from '@gift-variable-plugins/photo-shared/hasUserInput';
import { PhotoVariableInput } from '@gift-variable-plugins/photo-shared/PhotoVariableInput';
import { PhotoUploadData } from './PhotoUploadData';

export const handleError = (
    input: Draft<GiftJson.Input<PhotoVariableInput>>,
    requestMeta: PhotoUploadData
) => {
    if (hasUserInput(input.value) && input.value.cuid === requestMeta.cuid) {
        input.value.status = 'error';
    }
};